import { getLocale } from "../runtime";

const sv_showsubcategories = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Visa alla underkategorier`
};

const showsubcategories = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_showsubcategories(inputs)
	return "showSubCategories";
};

export { showsubcategories as "showSubCategories" };